// Runs one download-request form submission (#9).
//
// `descriptor` is what the list pages hand the form modal:
//   submit(details)   – performs the POST; MUST throw on failure so the modal
//                       stays open with the user's input.
//   afterSubmit(res)  – optional refresh/follow-up (refetch, flip rows, open
//                       the approved-download modal). It is handed the
//                       server's response so it can tell a request that
//                       landed from one the server left alone.
//   clearSelection    – when true the multi-selection is cleared on success.
//
// Order on success is fixed: close the modal, clear the selection, THEN run
// the follow-up — a failing refresh can never keep the modal open or leave
// the selection behind (the request has already been accepted).
export async function runDownloadRequestSubmit(descriptor, details, { close, clearSelection, onAfterSubmitError }) {
    const result = await descriptor.submit(details);          // throws → modal stays open
    close();
    if (descriptor.clearSelection) clearSelection();
    try {
        await descriptor.afterSubmit?.(result);
    } catch (e) {
        if (onAfterSubmitError) onAfterSubmitError(e);
    }
}
